import React from "react";

import { AzFormCallback } from "@Development/ui-kit";
import qs from "querystringify";

import getAppTrackingParams from '../utils/getTrackingParams';
import {arenzaStorage} from "arenza-test/src/core/storage";

export default function ConsultationForm() {
  let utmLocation = arenzaStorage.session('utmTagsInUrl');

  const manupulateWithUtm = (utm_source, utm_full) => {
    if (localStorage.getItem('_ym_uid')) {
      const yuid = localStorage.getItem('_ym_uid').replaceAll('"', '');

      if (utmLocation?.includes('?')) {
        utmLocation += `&ym_uid=${yuid}`
      } else {
        utmLocation += `?ym_uid=${yuid}`
      }
    }

    if (window?.Comagic) {
      const comagicId = window.Comagic.getVisitorId();

      if (utmLocation?.includes('?')) {
        utmLocation += `&comagic_id=${comagicId}`
      } else {
        utmLocation += `?comagic_id=${comagicId}`
      }
    }

    if (utmLocation.includes('utm_source')) {
      let urlParam = qs.parse(utmLocation);

      utm_source.current = urlParam.utm_source;
    }

    utm_full.current = utmLocation;
  };

  const addTrackingParams = (formData, utm_full, utm_source) => {
      const trackingParams = getAppTrackingParams(utm_full.current);
      Object.entries(trackingParams).forEach(([key, value]) => {
        if (utm_source.current === 'avito' && key === 'channel') {
          formData.append('channel', utm_source.current);
        } else if (utm_source.current === 'avito' && key === 'landing_url') {
          formData.append('landing_url', utm_full.current);
        } else {
          formData.append(key, value);
        }
      });
  };

  return (
    <AzFormCallback
      urlAdvertisement={`${process.env.GATSBY_DOCUMENTS_PUBLIC_URL}/acceptances/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%BD%D0%B0_%D1%80%D0%B5%D0%BA%D0%BB%D0%B0%D0%BC%D0%BD%D1%83%D1%8E_%D1%80%D0%B0%D1%81%D1%81%D1%8B%D0%BB%D0%BA%D1%83_%D0%90%D1%80%D0%B5%D0%BD%D0%B7%D0%B0.pdf`}
      urlFrontOfficeBackend={process.env.GATSBY_FRONTOFFICE_API || ''}
      urlDocuments={`${process.env.GATSBY_DOCUMENTS_PUBLIC_URL}/acceptances/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%BD%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83_%D0%9F%D0%94_%D0%90%D1%80%D0%B5%D0%BD%D0%B7%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D1%82%D0%BD%D1%8B%D0%B9_%D0%B7%D0%B2%D0%BE%D0%BD%D0%BE%D0%BA_%D1%81%D0%B0%D0%B9%D1%82%D0%B0.pdf`}
      addTrackingParams={addTrackingParams}
      manupulateWithUtm={manupulateWithUtm}
    />
  );
}
